import React, { type FC } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import numberToText from '../utils/numberToText'
import StructuredText from './StructuredText'

interface IProps {
  answersLeft: number
  answersRequired: number
  explanation: IQuestion['explanation']
}

const Explanation: FC<IProps> = ({ answersLeft, answersRequired, explanation }) => {
  return (
    <div className='lg:col-span-2 min-h-[5rem]'>
      <AnimatePresence mode='wait'>
        {answersRequired > 1 && answersLeft > 0 && (
          <motion.p
            key={'answersLeft'}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className={`text-sunriseGold lg:text-xl`}
          >
            {numberToText(answersLeft)} required.
          </motion.p>
        )}
        {answersLeft === 0 && (
          <motion.p
            key={'explanation'}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <StructuredText
              className='lg:text-xl explanation wysiwyg'
              data={explanation}
            />
          </motion.p>
        )}
      </AnimatePresence>
    </div>
  )
}

export default Explanation
